<template lang="pug">
	.page
			.poster
				.wrapper
					.poster__outer
						router-link.back(to='/cultures/' data-aos="fade-up" data-aos-delay="200") всі культури
							span
						.poster__image(data-aos="fade" :style="{backgroundImage: 'url(\"' + (page.image ? page.image[1200] : '')  + '\")'}")
						.poster__content(data-aos="fade-up" data-aos-delay="200") {{ page.name }}
							a.poster__btn(v-if="activeCulture.file" :href="activeCulture.file" target="_blank") Брошура  pdf
								span
			.crop__title( v-if="crop.length && oneCrop != null") {{ getCropById(page.id).name }}
			.crop__container( v-if="crop.length && oneCrop != null")

				table.crop
					crop-row(
						v-for="(row , i) in rows"
						v-bind:periods="getCropById(page.id).periods"
						v-bind:oneCrop="oneCrop"
						v-bind:rowLevel="row.level"
						v-bind:horPos="horPos"
						:key="i"
					)

			.wrapper(v-if="page.id && getProductsByCulture(page.id).length")
				.cultures
					.cultures__title(data-aos="fade-up") Пов’язані продукти
					.cultures__swiper-container(data-aos="fade-up" data-aos-delay="200")
						.cultures__swiper-wrapper
							swiper.cultures__swiper(ref="swiper1" :options="{allowTouchMove: false,loop: (getProductsByCulture(page.id).length <= 4 ? false : true),slidesPerView: 4,breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
								swiperSlide(
									v-for="(card, index) in getProductsByCulture(page.id)"
									:key="index"
								)
									section-card(
										:card="card"
										:type="'product'"
										:link="'/products/' + (catalogs.length ? getCatalogById(card.catalogs[0]).slug : '') + '/' + card.slug + '/'"
									)
						template(v-if="getProductsByCulture(page.id).length > 4")
							button.cultures__arrow.cultures__arrow_left( @click="slidePrev(1)")
							button.cultures__arrow.cultures__arrow_right( @click="slideNext(1)")
					.cultures__bottom(data-aos="fade-up")
						router-link.cultures__more(to='/products/') Всі продукти
							span
				.cultures.cultures_last(v-if="activeCulture && activeCulture.materials")
					.cultures__title(data-aos="fade-up") Пов’язані матеріали
					.cultures__swiper-container(data-aos="fade-up" data-aos-delay="200")
						.cultures__swiper-wrapper
							swiper.cultures__swiper(ref="swiper2" :options="{allowTouchMove: false,loop: (activeCulture.materials.length <= 4 ? false : true),slidesPerView: 4, breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
								swiperSlide(
									v-for="(card, index) in activeCulture.materials"
									:key="index"
								)
									section-card(
										:card="card"
										:type="'new_min'"
										:link="'/'+(card.type === 'Новини' ? 'news' : card.type === 'Статті' ? 'articles' : 'promos')+'/' + card.slug + '/'"
									)
						template(v-if="activeCulture.materials.length > 4")
							button.cultures__arrow.cultures__arrow_left( @click="slidePrev(2)")
							button.cultures__arrow.cultures__arrow_right( @click="slideNext(2)")


</template>

<script>

	import sectionCard from '@/components/sectionCard.vue';
	import Row from '@/blocks/includes/cropRow.vue';

	import AOS from 'aos';

	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'

	import {mapState, mapGetters} from 'vuex';

	export default {
		name: 'Culture',
		metaInfo: function() {
			let th = this;

			return {
				title: 'Культури — ' + th.page.name,
			}
		},
		data: function(){
			return {
				page: {},
				sl: this.$route.params.slug,
				horPos: [],
				rows: [],
				oneCrop: null,
				level: '',
				start: '',
				end: '',
				white: ''
			}
		},
		created() {
			if (!this.crop.length) this.$store.dispatch('GET_CROP');
			if (!this.cultures.length) this.$store.dispatch('GET_COLLECTION', 'cultures');
			if (!this.protection.length) this.$store.dispatch('GET_COLLECTION', 'crop-protection-systems');
			if (!this.products.length) this.$store.dispatch('GET_COLLECTION', 'products');
			if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'catalogs');
			if (!this.news.length) this.$store.dispatch('GET_COLLECTION', 'news');
			if (!this.articles.length) this.$store.dispatch('GET_COLLECTION', 'articles');

			this.check();
		},
		methods: {
			check() {
				if (this.cultures.length) {
					this.page = this.getCultureBySlug(this.$route.params.slug);
					this.$store.dispatch('GET_ACTIVE_CULTURE', this.page.id);
				}
			},
			resizeHandler() {
				setTimeout(() => {
					if (this.$refs.swiper1) this.$refs.swiper1.swiper.update();
					if (this.$refs.swiper2) this.$refs.swiper2.swiper.update();
				});
			},
			filterCropBlocks() {
				let levels = [];
				this.getCropById(this.page.id).blocks.forEach(item => {
					levels.push(item.level);
				});
				let i = Math.max.apply(null, levels) + 1;

				while( i > 1) {
					i = i - 1;
					let level = this.crop[0].blocks.filter( item => item.level == i);
					if (level[0] == undefined) {
						let mask = {};
						mask.level = i;
						this.rows.push(mask);
					} else {
						this.rows.push(level[0]);
					}
				}
			},
			collectHorPos() {
				this.getCropById(this.page.id).periods.forEach( item => {
					this.horPos.push(item.id);
				})
			},
			createC() {
				let arr = this.getCropById(this.page.id).blocks;
				arr.forEach(item => {
					if( item.primary.length != 0 ) {
						item.primary.forEach(block => {
							if(block.products[0].additional_product != null) {
								block.products[0].product.start = block.start;
								// block.products[0].product.end = this.horPos[this.fhp(block.end) - 1];
								block.products[0].product.end = block.end
							} else {
								block.products[0].product.start = block.start;
								block.products[0].product.end = block.end;
							}
							block.level = item.level
							block.startAdd = this.horPos[this.fhp(block.end) -1];
							block.endAdd = block.end;
						})
					}
					if (item.secondary.length != 0) {
						item.secondary.forEach(sec => {


							if(sec.products[0].additional_product != null) {
								sec.products[0].product.start = sec.start;
								// sec.products[0].product.end = this.horPos[this.fhp(sec.end) - 1];
								sec.products[0].product.end = sec.end
							} else {
								sec.products[0].product.start = sec.start;
								sec.products[0].product.end = sec.end;
							}

							sec.level = item.level;
							sec.startAdd = this.horPos[this.fhp(sec.end) -1];
							sec.endAdd = sec.end;
						})
					}
				})

				this.oneCrop = arr;
			},
			fhp(id) {
				return this.horPos.indexOf(id);
			},
			slideNext(id) {
				if(id == 1) this.$refs.swiper1.swiper.slideNext();
				if(id == 2) this.$refs.swiper2.swiper.slideNext();
			},
			slidePrev(id) {
				if(id == 1 ) this.$refs.swiper1.swiper.slidePrev();
				if(id == 2 ) this.$refs.swiper2.swiper.slidePrev();
			}
		},
		updated() {
			if(this.crop.length && this.getCropById(this.page.id) != 0) this.createC();
		},
		mounted() {
			window.addEventListener('resize', this.resizeHandler, false);

			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
				if(this.crop.length && this.getCropById(this.page.id) != 0) {

					this.collectHorPos();
					this.createC();
					this.filterCropBlocks();
				}
			})
		},
		destroyed() {
			window.removeEventListener('resize', this.resizeHandler, false);
		},
		components: {
			'section-card': sectionCard,
			swiper,
			swiperSlide,
			'crop-row': Row,
		},
		computed: {
			...mapState([
				'cultures',
				'protection',
				'products',
				'catalogs',
				'crop',
				'news',
				'articles',
				'activeCulture',
			]),
			...mapGetters([
				'getCultureBySlug',
				'getProductsByCulture',
				'getCatalogById',
				'chooseColor',
				'getCropById'
			])
		},
		watch: {
			cultures() {
				this.check();
			},
			protection() {
				this.check();
			},
			catalogs() {
				this.check();
			},
			products() {
				this.check();
			},
			crop() {
				this.filterCropBlocks();
				this.collectHorPos();
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

  >>> .white {
		position: relative;

		&::after {
			position: absolute;
			content: '';
			top: 0;
			left: 0;
			width: 100%;
			height: calc(100% + 10px);
			background-color: #fff;
			z-index: -1;
		}
	}

  >>> .divider {
		position: absolute;
		bottom: 50%;
		left: 0;
		width: 50%;
		background-color: #f7f7f7;
		transform: translate(-50%, -50%);
		z-index: 1;

		&__container {
			width: 100%;
			height: 100%;
			padding: 10px 0;
			position: relative;
			text-align: center;
			z-index: 2;
			font: 300 10px/1.3 'Helvetica', sans-serif;
			letter-spacing: 0.05em;
			color: transparent;

			&:before {
				position: absolute;
				top: 0;
				right: 0;
				width: 100%;
				height: auto;
				text-align: center;
				border: 1px solid #dbdbdb;
				content: 'Або';
				font: 300 10px/1.3 'Helvetica', sans-serif;
				letter-spacing: 0.05em;
				color: #333333;
				transform: translate(0, 0);
				z-index: 2;
				padding: 10px 0;
			}
		}

		&__line {
			position: absolute;
			top: 50%;
			left: 50%;
			height: 10px;
			background-color: #f2f2f2;
			transform: translate(0, -50%);
			z-index: -1;
			opacity: .5;

		}
	}

  >>> .row__img {
		display: none;
	}

  >>> .tr {
		width: 100%;
		border-spacing: 0!important;
		border: 0;
		position: relative;
	}

	.crop {
		width: 100%;
		border: 1px solid grey;
		border-collapse: collapse;
		table-layout: fixed;
		min-width: 1282px;
		max-width: 1282px;
		margin: 0 auto;



		&__title {
			font: 700 42px/1.2 'Helvetica', 'Arial', sans-serif;
			color: #333333;
			letter-spacing: 0.05em;
			padding-top: 92px;
			max-width: 1280px;
			margin: 0 auto;
		}


		&__container {
			width: 100%;
			margin: 12px auto -30px;
			overflow-x: hidden;
			overflow-y: auto;
			padding: 35px 0 250px;

			&::-webkit-scrollbar,
			&::-webkit-scrollbar-button,
			&::-webkit-scrollbar-track,
			&::-webkit-scrollbar-track-piece,
			&::-webkit-scrollbar-thumb,
			&::-webkit-scrollbar-corner,
			&::-webkit-resizer {
				display: none;
			}

		}

		&__row {
			width: 100%;
			border-spacing: 0!important;
			border: 0;
			position: relative;


			&:nth-child(1) {
        >>> .td__period {
					display: block;

					&_bottom {
						display: none;
					}
				}
			}

			&:last-child {
        >>>.td__img {
					display: block!important;
				}

        >>> .td__period_bottom {
					display: block;
				}

        >>> .td {
					padding-bottom: 2px;
					&:nth-last-child(2) {
						.row__img {
							width: 100%;
							height: 165px;
							background-size: contain;
							background-repeat: no-repeat;
							background-position: center;
							position: absolute;
							bottom: -190px;
							right: -50%;
							display: block;
						}
					}
				}
			}
		}

    >>> .td {
			width: 100%;
			position: relative;
			vertical-align: top;
			padding: 5px 0 0 0;
			&:last-child {
				width: 0px!important;
				border-right: 0!important;
			}

			&:nth-last-child(2) {
				&:before {
					display: none;
				}
			}

			&:before {
				content: '';
				position: absolute;
				top: 0;
				left: 100%;
				width: 1px;
				height: 100%;
				background-color: #dbdbdb;
				z-index: 0;
				transform: translate(-50%, 0);
			}
		}

		&__white {

			&_active {
				background: #fff;
			}
		}

		>>> .cell {

			&__plus {
				z-index: 10;
				display: inline-block;
				vertical-align: middle;
				width: 100%;

				&_before {
					position: absolute;
					top: 50%;
					left: 100%;
					width: 30px;
					height: 100%;
					font: 700 14px/3.5 'Helvetica', 'Arial', sans-serif;
					color: #fff;
					text-align: center;
					transform: translate(-50%, -50%);
					z-index: 10;
					background: inherit;
					pointer-events: none;
				}


				&_before-cont {
					width: 100%;
					height: 100%;
					position: relative;

					&:before {
						content: '+';
						top: 50%;
						left: 50%;
						position: absolute;
						transform: translate(-50%, -50%);
					}
				}
			}
		}

		>>> .td__period {
			position: absolute;
			top: -25px;
			left: -10px;
			font: 700 14px/1.3 'Helvetica', 'Arial', sans-serif;
			color: #333333;
			display: none;

			&_last {
				font: 700 14px/1.3 'Helvetica', 'Arial', sans-serif;
				color: #333333;
				position: absolute;
				left: auto;
				top: -25px;
				right: -10px;
			}

			&_bottom {
				top: auto;
				bottom: -30px;
			}


		}

		>>> .td__img {
			width: 100%;
			height: 165px;
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center;
			position: absolute;
			bottom: -190px;
			left: -50%;
			display: none;
		}

		&__mask {
			background-color: #000;
			overflow: hidden;
			.crop {
				&__content {
					span {
						color: #fff;
					}
				}
			}
		}

		>>> .cell__block {
			min-height: 50px;
			color: #fff;
			margin-top: 5px;
			margin-bottom: 0;
			position: relative;
			display: block;
			z-index: 1;

			&:before {
				content: '';
				height: 100%;
				display: inline-block;
				vertical-align: middle;
			}

			&_add {
				z-index: 0;
			}

			@media screen and (min-width: 1201px) {
				&:hover {
					opacity: 1;
					.cell__plus_before {
						background-image: linear-gradient(90deg, rgba(0,0,0,0) 50%, rgba(0,0,0,.1) 50%, rgba(0,0,0,0) 100%);
					}
				}
			}

			&_secondary {
				position: relative;
			}
		}

		>>> .cell__content {
			width: 100%;
			display: inline-block;
			vertical-align: middle;
			padding: 7px;

			span {
				display: block;
				margin: 0 auto;
				font: 300 10px/1.3 'Hek=lvetica', 'Arial', sans-serif;
				color: #fff;
				text-align: center;
				letter-spacing: 0.05em;
				position: relative;
				z-index: 12;

				&:first-child {
					font-weight: 700;
					font-size: 14px;
					line-height: 1.3;
				}
			}
		}

		>>> .crop {
			&__inner {
				width: 100%;
				border: 0;
				border-collapse: collapse;
				table-layout: fixed;
				min-width: 1000px;
			}

			&__row {
				&_inner {
					width: 100%;
					border-spacing: 0!important;
					border: 0;
					position: relative;
				}
			}
		}

		>>> .secondary {
			.td {
				padding-top: 0;
			}
			.cell {
				min-height: 0;

				&__block {
					margin-top: 30px;
				}
			}
		}

		>>> .test {
			position: absolute;
			top: 0;
			left: 100%;
			width: calc(100% + 1px);
			height: 100%;
			background-color: #000;
			pointer-events: none;

			.cell__block {
				margin-top: 0;
				pointer-events: none;
			}
		}
	}

	.back {
		text-transform: uppercase;
		display: inline-block;
		height: 50px;
		box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
		position: absolute;
		left: 0;
		top: 0;
		width: 247px;
		background-color: #EF3E33;
		text-transform: uppercase;
		color: #fff;
		font: 500 19px/52px 'Helvetica', Arial, sans-serif;
		margin-left: -50px;
		text-align: center;
		padding-left: 50px;
		letter-spacing: 2px;
		z-index: 1;

		&:after {
			content: "";
			display: block;
			position: absolute;
			width: calc(100% - 50px);
			height: 100%;
			top: 0;
			right: 0;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
		}

		span {
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 50px;
			height: 50px;
			background: url('../assets/img/back.svg') no-repeat center center;
		}

		@media screen and (min-width: 1201px) {
			&:hover {
				opacity: .7!important;
				transition: opacity .3s ease;
			}
		}
	}

	.poster {
		position: relative;

		&__outer {
			position: relative;
			height: 518px;
		}

		&__content {
			width: 630px;
			background-color: #fff;
			padding: 77px 20px 65px 105px;
			font: 700 42px/1.2 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			top: 50px;
			position: absolute;
			left: 0;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);
		}

		&__image {
			position: absolute;
			height: 100%;
			right: 0;
			width: calc(100% - 325px + 80px);
			background-size: cover;
			background-position: center;
			margin-right: -80px;
		}

		&__btn {
			position: absolute;
			top: 100%;
			left: 0;
			background-color: #EF3E33;
			height: 30px;
			width: 197px;
			padding-right: 30px;
			text-align: center;
			font: 500 11px/30px 'Helvetica', Arial, sans-serif;
			color: #fff;
			text-transform: uppercase;
			letter-spacing: 1px;

			&:after {
				content: "";
				display: block;
				position: absolute;
				width: calc(100% - 30px);
				height: 100%;
				top: 0;
				left: 0;
				box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			}

			span {
				position: absolute;
				display: block;
				width: 30px;
				height: 100%;
				right: 0;
				top: 0;
				background: url('../assets/img/dwn.svg') no-repeat center center;
			}
		}
	}

	.page {
		margin-top: 0;
		margin-bottom: 100px;
	}

	.cultures {
		margin-top: 38px;
		margin-bottom: 94px;

		&:last-child {

		}

		&_last {
			margin-bottom: -88px;
		}

		&__title {
			@include kit('sectionTitle');
			margin-left: 0;
			margin-bottom: -22px;
		}

		&__swiper {
			width: calc(100% + 20px);
			margin-left: -10px;
			margin-top: 12px;
		}

		&__swiper-container {
			position: relative;
		}

		&__swiper-wrapper {
			overflow: hidden;
			width: 100%;
			height: 100%;
		}

		&__arrow {
			position: absolute;
			top: 62px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 0;

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: -49px;
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				right: -49px;
			}
		}

		>>> .card {
			margin-bottom: 57px;
			margin-top: 20px;
		}

		&__bottom {
			text-align: center;
			position: relative;
			z-index: 1;
		}

		&__more {
			height: 50px;
			width: 296px;
			max-width: 100%;
			border: 1px solid #EF3E33;
			position: relative;
			display: inline-block;
			vertical-align: top;
			text-transform: uppercase;
			margin-top: 23px;
			padding-right: 50px;
			text-align: center;
			color: #EF3E33;
			font: 500 19px/52px 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			position: relative;

			span {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				width: 50px;
				height: 100%;
				background: url('../assets/img/arr_3.svg') no-repeat center center;
				border-left: 1px solid #EF3E33;
			}
		}
	}

	>>> .swiper-container {
		padding: 30px 0;
	}

	@media screen and (max-width: 1200px) {
		.page {
			margin-top: 30px;
		}

		.back {
			background-color: #fff;
			color: #333;
			margin-left: -20px;
			position: relative;

			span {
				background: url('../assets/img/back_red.svg') no-repeat center center;
				position: absolute;
				top: 0;
				left: 0;
				width: 50px;
				height: 100%;
			}
		}

		.poster {
			&__outer {
				height: auto;
				margin-bottom: 74px;
			}

			&__image {
				position: relative;
				top: 0;
				left: 0;
				right: auto;
				width: calc(100% + 40px);
				margin-left: -20px;
				height: 374px;
			}

			&__content {
				position: relative;
				top: 0;
				left: 0;
				width: 100%;
				margin-top: -50px;
				padding: 50px 20px;
				font-size: 28px;
				line-height: 33px;
			}

			&__btn {
				min-width: 0;
				width: auto;
				padding: 0 50px 0 20px;
			}
		}

		.cultures {
			&__arrow {
				display: none;
			}

			&__title {
				margin-bottom: -2px;
			}

			&__more {
				margin-top: 24px;
			}

			.section__swiper-container {
				width: calc(100% + 40px);
				margin-left: 0px;
			}

			>>> .swiper-slide {
				padding: 0 10px;
				width: 266px;
			}

			>>> .card {
				width: 246px;
				margin: 0;
			}

			&_last {
				margin-bottom: -30px;
			}
		}

		.crop {
			min-width: 1280px;
			&__container {
				padding: 35px 40px 250px;
				margin-top: 12px;
				overflow-x: scroll;
			}

			&__title {
				font-size: 28px;
				line-height: 1.2;
				padding: 74px 0 0 20px;
				letter-spacing: 0.04em;
				padding-top: 0;
			}
		}
	}

</style>
